// extracted by mini-css-extract-plugin
export default {"component":"SidebarFooter_component__qi2Gp","darkMode":"SidebarFooter_darkMode__V98L-"};